/**
 * «حذف مخاطب» — the one confirmation, used by the profile AND the contacts list.
 *
 * One component rather than two copies, because the promise it makes — hidden
 * from lists, history untouched, an ADMIN can restore it — is the same promise
 * wherever the button sits, and two dialogs would drift into two wordings of
 * it. It is a SOFT delete: erasure stays where it was, on an already-deleted
 * contact's profile, two deliberate steps away.
 *
 * The dialog closes on confirm (ConfirmDialog's contract), so a refusal cannot
 * be shown inside it; it goes to `onError` for the screen to render.
 */
import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import { ConfirmDialog, TextField } from '../FormKit.web.jsx';
import { DELETE_CONTACT } from '../../lib/queries.js';
import { S } from '../../lib/strings.js';

export function DeleteContactDialog({ contact, open, onOpenChange, onDeleted, onError }) {
  const [reason, setReason] = useState('');
  const [deleteContact] = useMutation(DELETE_CONTACT);

  if (!contact) return null;

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(next) => {
        onOpenChange(next);
        if (!next) setReason('');
      }}
      title={S.contacts.detail.deleteContact}
      message={S.contacts.detail.confirmDelete(contact.displayName)}
      confirmLabel={S.app.delete}
      danger
      onConfirm={async () => {
        onError?.(null);
        try {
          await deleteContact({
            variables: { id: contact.id, reason: reason.trim() || null },
          });
          onDeleted?.();
        } catch (err) {
          onError?.(err);
        }
      }}
    >
      <TextField
        label={S.contacts.detail.deleteReason}
        hint={S.app.optional}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
      />
    </ConfirmDialog>
  );
}
